import { computed, effect, signal } from "@lit-labs/preact-signals";
import { getItem } from "../helpers/getItem";

const USER_OBJECT_KEY = "user";
const USER_ID_KEY = "id";
const USER_TIMEZONE_KEY = "timezone";

/* store with the data about user and its login */
function createAuthStore() {
  const userObject = signal(getItem(USER_OBJECT_KEY, ""));
  const userId = signal(localStorage.getItem(USER_ID_KEY) || "");
  const userRole = computed(() =>
    userObject.value &&
    userObject.value.persona.toLowerCase().includes("founder")
      ? "founder"
      : "professional"
  );
  const userTimezone = signal(localStorage.getItem(USER_TIMEZONE_KEY) || "");

  // effects
  const userIdDispose = effect(() => {
    localStorage.setItem(USER_ID_KEY, userId.value);
  });
  const userObjectDispose = effect(() => {
    localStorage.setItem(USER_OBJECT_KEY, JSON.stringify(userObject.value));
  });
  const userTimezoneDispose = effect(() => {
    localStorage.setItem(USER_TIMEZONE_KEY, userTimezone.value);
  });

  return {
    userObject,
    userId,
    userRole,
    userTimezone,
  };
}

export const authStore = createAuthStore();
